import React, { useState, useCallback, useContext, useEffect } from 'react';
import { Modal, Button, Form, Tabs, Tab, Row, Col } from 'react-bootstrap';
import './OpenContactModal.css'
import { useTranslation } from "react-i18next";
import AlertContext from '../../../context/AlertModelContext/AlertModalContext';
import { createContactList, editContactList } from '../../../axios/requests/contactListReq';
import { getDropDownList } from '../../../axios/requests/dropDownReq'
import DropDownV2 from '../../UI/DropDownV2/DropDownV2';
import ActivityContact from './ActivityContact';
import InquirieContact from './InquirieContact';

const defaultSelectedClassificationType = {
  key: 'Select Contact Type',
  value: 'Select Contact Type'
}

const OpenContactModal = (props) => {
  const alertCtx = useContext(AlertContext)
  const [t] = useTranslation('common')

  const [fullName, setFullName] = useState('');
  const [mainPhone, setMainPhone] = useState('');
  const [email, setEmail] = useState(undefined);
  const [remarks, setRemarks] = useState('');
  const [fromCompanyName, setFromCompanyName] = useState('');

  const [dropDownClassificationTypeState, setDropDownClassificationTypeState] = useState([])
  const [classificationTypeSelectedItem, setClassificationTypeSelectedItem] = useState({})

  const [activeTab, setActiveTab] = useState('details');

  const hasContactId = Boolean(
    (props.selectedConv?.contactId && props.whereTypped === 'CONV') ||
    (props.callSelected?.callObj?.contactId && props.whereTypped === 'DIALER') ||
    (props.dialItemSelected?.dialListObj?.contactId && props.whereTypped === 'DIALLIST') ||
    (props.nowSelectedContact?._id && props.whereTypped === 'CONTACT' && props.whereTypped !== 'NOACTIVITIYTAB')
  );


  const fetchAllDropdownListData = useCallback(async (classificationList) => {
    const initialDropdownValues = {};
    let allDropDownsFetch = await getDropDownList('CONTACT_CLASSIFICATION');

    const updatedDropDowns = allDropDownsFetch.map(dropdown => {
      return {
        ...dropdown,
        dropDownItems: [defaultSelectedClassificationType, ...dropdown.dropDownItems.filter(item => item.value !== defaultSelectedClassificationType.value)],
      };
    });

    updatedDropDowns.forEach((dropdown) => {
      // If there's already a selected value for this dropdown, use it. otherwise, set to default
      const existingSelection = classificationList?.find(cl => cl.dropDownName === dropdown.name);
      initialDropdownValues[dropdown.name] = existingSelection ? {
        key: existingSelection.dropDownValue,
        value: existingSelection.dropDownValue,
      } : defaultSelectedClassificationType;
    });

    setClassificationTypeSelectedItem(initialDropdownValues);
    setDropDownClassificationTypeState(updatedDropDowns);
  }, [setDropDownClassificationTypeState, setClassificationTypeSelectedItem]);



  const onSelectHandler = useCallback((selectedItem, name) => {
    setClassificationTypeSelectedItem(prevState => ({
      ...prevState,
      [name]: selectedItem
    }));
  }, []);


  const checkMailIfExample = (email) => {
    return email?.includes('@example') ? '' : email;
  };

  useEffect(() => {
    // fetchAllDropdownListData()
    if (props.selectedConv && props.contactListMode === 'add' && props.whereTypped === 'CONV') {
      resetFormContactList();
      setEmail("")
      setMainPhone(props.selectedConv?.clientName)

      let contactName = '';

      if (props.selectedConv?.msgType === 'mail') {
        setFullName("")
        setEmail(props.selectedConv?.clientName)
        setMainPhone("")
        return
      }

      if (props.selectedConv?.crmId?.name) {
        contactName = props.selectedConv?.crmId?.name;
        setFullName(contactName);
        return
      } else if (props.selectedConv?.displayName && !props.selectedConv.displayName.startsWith('+972')) {
        contactName = props.selectedConv.displayName;
        setFullName(contactName);
        return
      }

    }
    else if (props.callSelected && props.contactListMode === 'add' && props.whereTypped === 'DIALER') {
      resetFormContactList();
      setEmail("")
      setMainPhone(props.callSelected?.telephone)
      setFullName(props.callSelected?.callObj?.crmId?.name || '')
    }
    else if (props.dialItemSelected && props.contactListMode === 'add' && props.whereTypped === 'DIALLIST') {
      resetFormContactList();
      setEmail("")
      setMainPhone(props.dialItemSelected?.telephone)
      setFullName(props.dialItemSelected?.dialListObj?.crmId?.name || '')
    }
  }, [props.selectedConv, props.whereTypped, props.contactListMode, props.selectedConv?.clientName, props.callSelected, props.callSelected?.telephone, props.dialItemSelected, props.dialItemSelected?.telephone])

  useEffect(() => {
    if (props.contactListMode === 'edit' && props.nowSelectedContact && props.whereTypped === 'CONTACT') {
      setFullName(props.nowSelectedContact.fullName || '');
      setMainPhone(props.nowSelectedContact.mainPhone.replace(/^\+972/, '0') || '');
      // setEmail(props.nowSelectedContact.email || '');
      setEmail(checkMailIfExample(props.nowSelectedContact.email));
      setRemarks(props.nowSelectedContact.remarks || '');
      setFromCompanyName(props.nowSelectedContact.fromCompanyName || '');

      fetchAllDropdownListData(props.nowSelectedContact.classificationList)

    }
    else if (props.contactListMode === 'add' && props.whereTypped === 'CONTACT' || props.whereTypped === 'NOACTIVITIYTAB') {
      resetFormContactList();
      setEmail("")
    }
    else if (props.contactListMode === 'edit' && props.whereTypped === 'CONV') {
      setFullName(props.selectedConv?.contactId?.fullName || '');
      setMainPhone(props.selectedConv?.contactId?.mainPhone.replace(/^\+972/, '0') || '');
      // setEmail(checkMailIfExample(props.selectedConv?.contactId?.email));
      setRemarks(props.selectedConv?.contactId?.remarks || '');
      setFromCompanyName(props.selectedConv?.contactId?.fromCompanyName || '');

      fetchAllDropdownListData(props.selectedConv?.contactId?.classificationList)
      if (!props.selectedConv?.contactId?.email) {
        setEmail("")
      }
      else {
        setEmail(checkMailIfExample(props.selectedConv?.contactId?.email));
      }
    }
    else if (props.contactListMode === 'edit' && props.whereTypped === 'DIALER') {
      setFullName(props.callSelected?.callObj?.contactId?.fullName || '');
      setMainPhone(props.callSelected?.callObj?.contactId?.mainPhone.replace(/^\+972/, '0') || '');
      // setEmail(props.callSelected?.callObj?.contactId?.email || '');
      setEmail(checkMailIfExample(props.callSelected?.callObj?.contactId?.email));
      setRemarks(props.callSelected?.callObj?.contactId?.remarks || '');
      setFromCompanyName(props.callSelected?.callObj?.contactId?.fromCompanyName || '');

      fetchAllDropdownListData(props.callSelected?.callObj?.contactId?.classificationList)
    }
    else if (props.contactListMode === 'edit' && props.whereTypped === 'DIALLIST') {
      setFullName(props?.dialItemSelected?.dialListObj?.contactId?.fullName || '');
      setMainPhone(props?.dialItemSelected?.dialListObj?.contactId?.mainPhone.replace(/^\+972/, '0') || '');
      // setEmail(props?.dialItemSelected?.dialListObj?.contactId?.email || '');
      setEmail(checkMailIfExample(props?.dialItemSelected?.dialListObj?.contactId?.email));
      setRemarks(props?.dialItemSelected?.dialListObj?.contactId?.remarks || '');
      setFromCompanyName(props?.dialItemSelected?.dialListObj?.contactId?.fromCompanyName || '');

      fetchAllDropdownListData(props.dialItemSelected?.dialListObj?.contactId?.classificationList)
    }
    // else {
    //   resetFormContactList();
    // }
  }, [props.nowSelectedContact, props.contactListMode, props.whereTypped, props.selectedConv?.contactId, props.selectedConv, props.callSelected, props.dialItemSelected]);

  const onHide = props.onHide

  const onHideMiddleware = useCallback(() => {
    setActiveTab('details');
    onHide()
  }, [onHide])

  const resetFormContactList = () => {
    setFullName('');
    setMainPhone('');
    setEmail(undefined);
    setRemarks('')
    setFromCompanyName('')
    setClassificationTypeSelectedItem({})
  }

  const sourceTypeDisplayMapping = {
    APP: t('Application Source Type'),
    CRM: 'CRM',
    WHATSAPP: t('WhatsApp Source Type')
  };

  const getSourceTypeDisplayValue = () => {
    const rawValue = getSourceTypeValue();
    return sourceTypeDisplayMapping[rawValue] || rawValue;
  };

  const getSourceTypeValue = () => {
    if (props.contactListMode === 'edit') {
      if (props.whereTypped === 'CONTACT') {
        return props.nowSelectedContact?.sourceType || '';
      } else if (props.whereTypped === 'CONV') {
        return props.selectedConv?.contactId?.sourceType || '';
      } else if (props.whereTypped === 'DIALER') {
        return props.callSelected?.callObj?.contactId?.sourceType || '';
      } else if (props.whereTypped === 'DIALLIST') {
        return props.dialItemSelected?.dialListObj?.contactId?.sourceType || '';
      }
    }
    return '';
  };

  const sourceTypeDisplayValue = getSourceTypeDisplayValue();

  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const formatAndValidateIsraeliPhoneNumber = (phone) => {
    let formattedPhone = phone.replace(/-/g, '').replace(/^\+972/, '0').replace(/^972/, '0');
    const israeliPhonePattern = /^(0)([23489]|5[012345789]|7[2346789])[0-9]{7}$/;

    const isValid = israeliPhonePattern.test(formattedPhone);

    return {
      isValid,
      formattedPhone,
    };
  };

  const handleCreateContact = async (e) => {
    e.preventDefault();

    if (!fullName || !mainPhone) {
      alertCtx.showAlert(t('fail'), t('Full name and main phone number are required'), 'sm');
      return;
    }

    const { isValid, formattedPhone } = formatAndValidateIsraeliPhoneNumber(mainPhone);

    if (!isValid) {
      alertCtx.showAlert(t('fail'), t('Please enter a valid Israeli phone number'), 'sm');
      return;
    }

    if (email && !isValidEmail(email)) {
      alertCtx.showAlert(t('fail'), t('Please enter a valid email'), 'sm');
      return;
    }

    const classificationList = dropDownClassificationTypeState.map((item, index) => ({
      dropDownName: item.name,
      dropDownValue: classificationTypeSelectedItem[item.name] && classificationTypeSelectedItem[item.name].value ? classificationTypeSelectedItem[item.name].value : `${t('Classifications')}`
    }));

    const contactObject = { fullName, mainPhone: formattedPhone, email, remarks, fromCompanyName, classificationList };

    try {
      let response;
      if (props.contactListMode === 'edit') {
        // from msgs tab
        if (props.contactListMode === 'edit' && props.whereTypped === 'CONV') {
          const contactId = props.selectedConv?.contactId?._id;
          response = await editContactList(contactId, contactObject);
          resetFormContactList()
        }
        // from dialer tab
        if (props.contactListMode === 'edit' && props.whereTypped === 'DIALER') {
          const contactId = props.callSelected?.callObj?.contactId?._id;
          response = await editContactList(contactId, contactObject);
          resetFormContactList()
        }
        // from dialerList tab
        if (props.contactListMode === 'edit' && props.whereTypped === 'DIALLIST') {
          const contactId = props.dialItemSelected?.dialListObj?.contactId?._id;
          response = await editContactList(contactId, contactObject);
          resetFormContactList()
        }
        // from contactList tab
        else if (props.contactListMode === 'edit' && props.nowSelectedContact?._id) {
          const contactId = props.nowSelectedContact?._id;
          response = await editContactList(contactId, contactObject);
          resetFormContactList()
        }
      } else if (props.contactListMode === 'add') {
        response = await createContactList(contactObject);
        // resetFormContactList()
      }

      if (response && response.error) {
        let errorEmail = response?.error?.message;
        if (errorEmail && email && !isValidEmail(email)) {
          alertCtx.showAlert(t('fail'), t('Please enter a valid email'), 'sm');
          return;
        }

        let errorMessage = response?.error.errors?.mainPhone?.message;
        if (errorMessage) {
          alertCtx.showAlert(t('fail'), t('Please enter a valid Israeli phone number'), 'sm');
          return;
        }
        let errorDuplicatePhone = response?.error?.error?.code;
        if (errorDuplicatePhone === 11000) {
          alertCtx.showAlert(t('fail'), t('Duplicate Phone Number'), 'sm');
          return;
        }

        let errorFullNameVeryLong = response?.error?.error?.errors?.fullName?.message;
        if (errorFullNameVeryLong) {
          alertCtx.showAlert(t('fail'), t('Please enter a valid FullName length'), 'sm');
          return;
        }

        if (response.error?.status === "error" || !response) {
          alertCtx.showAlert(t('fail'), t('An error occurred, please try again later'), 'sm');
          return
        }
        alertCtx.showAlert(t('fail'), t('An error occurred, please try again later'), 'sm');
        return;
      }

      resetFormContactList();
      alertCtx.showAlert(t('success'), props.contactListMode === 'edit' ? t('The contact has been updated successfully') : t('The record has been added to the phone book'), 'sm');
      onHide();
    } catch (error) {
      console.error("Error in creating/editing contact", error);
      let errorDuplicatePhone = error?.errors?.code;
      if (errorDuplicatePhone === 11000) {
        alertCtx.showAlert(t('fail'), t('Duplicate Phone Number'), 'sm');
        return;
      }
    }
  };

  const tabTitles = {
    details: t('Details'),
    activity: t('Activitys'),
    inquiries: t('Inquiries')
  };

  return (
    <>
      <Modal show={props.show} onHide={onHideMiddleware} dialogClassName="my-modal" size="xl" centered aria-labelledby="contained-modal-title-vcenter" className='rtl-modal' >
        <Modal.Header>
          <Modal.Title>{tabTitles[activeTab]}</Modal.Title>
        </Modal.Header>
        <Modal.Body className='modal-body-style'>
          <Tabs className='cusTabs-contactlist open-contact-modal-tabs' defaultActiveKey='details' id='contact-tab' activeKey={activeTab} onSelect={(currentTab) => setActiveTab(currentTab)}>
            <Tab tabClassName='details-tab tab-border' eventKey='details' title={`${t('Details')}`}>
              <Form id="contactForm" className='contactlist-form' onSubmit={handleCreateContact}>
                <Row>
                  <Col md={5}>
                    <Form.Group controlId='fullname'>
                      <Form.Label className='header-title-style'>{t('Full Name')}</Form.Label>
                      <Form.Control type='text' value={fullName} onChange={(e) => setFullName(e.target.value)} required />
                    </Form.Group>
                  </Col>
                  <Col md={5}>
                    <Form.Group controlId='mainphonenumber'>
                      <Form.Label className='header-title-style'>{t('Main Phone Number')}</Form.Label>
                      <Form.Control type='text' value={mainPhone} onChange={(e) => setMainPhone(e.target.value)} required />
                      {/* <Form.Control type='text' value={props.selectedConv?.clientName || mainPhone} onChange={(e) => setMainPhone(e.target.value)} required /> */}
                    </Form.Group>
                  </Col>
                  <Col md={5}>
                    <Form.Group controlId='email'>
                      <Form.Label className='header-title-style'>{t('Email Of Full Name')}</Form.Label>
                      <Form.Control type='text' value={email} onChange={(e) => setEmail(e.target.value)} />
                    </Form.Group>
                  </Col>
                  <Col md={5}>
                    <Form.Group controlId='companyname'>
                      <Form.Label className='header-title-style'>{t('Company Name')}</Form.Label>
                      <Form.Control type='text' value={fromCompanyName} onChange={(e) => setFromCompanyName(e.target.value)} />
                    </Form.Group>
                  </Col>
                </Row>

                {props.contactListMode === 'edit' && <Row>
                  <Col md={5}>
                    <Form.Group controlId='sourceType'>
                      <Form.Label className='header-title-style'>{t('Source Type')}</Form.Label>
                      <Form.Control type="text" readOnly className="read-only-input" value={sourceTypeDisplayValue} />
                    </Form.Group>
                  </Col>
                </Row>
                }


                <Row>
                  <Col md={10}>
                    <Form.Group controlId='remarks'>
                      <Form.Label className='header-title-style'>{t('Remarks')}</Form.Label>
                      <Form.Control as="textarea" type='text' rows={3} value={remarks} onChange={(e) => setRemarks(e.target.value)} />
                    </Form.Group>
                  </Col>
                </Row>

                <div className="custom-row-wrapper">
                  <label className="custom-row-label header-title-style text-change-style">{t('Classifications')}</label>
                  <Row>
                    {dropDownClassificationTypeState?.map((dropdownItem) => (
                      <Col md={6} key={dropdownItem.name}>
                        <DropDownV2
                          nowSelected={classificationTypeSelectedItem[dropdownItem.name] || defaultSelectedClassificationType}
                          onSelect={(selectedItem) => onSelectHandler(selectedItem, dropdownItem.name)}
                          label={dropdownItem?.name}
                          items={dropdownItem.dropDownItems}
                        />
                      </Col>
                    ))}
                  </Row>
                </div>

              </Form>
            </Tab>

            {
              hasContactId && (
                <Tab className='activity-tab' tabClassName='details-tab tab-border' eventKey='activity' title={`${t('Activitys')}`}>
                  <ActivityContact className='activity-tab'
                    nowSelectedContact={props.nowSelectedContact}
                    contactListMode={props.contactListMode}
                    whereTypped={props.whereTypped}
                    selectedConv={props.selectedConv}
                    callSelected={props.callSelected}
                    dialItemSelected={props.dialItemSelected} />
                </Tab>
              )
            }

            {
              hasContactId && (
                <Tab className='inquiries-tab' tabClassName='details-tab tab-border' eventKey='inquiries' title={`${t('Inquiries')}`}>
                  <InquirieContact className='inquiries-tab'
                    nowSelectedContact={props.nowSelectedContact}
                    contactListMode={props.contactListMode}
                    whereTypped={props.whereTypped}
                    selectedConv={props.selectedConv}
                    callSelected={props.callSelected}
                    dialItemSelected={props.dialItemSelected}

                    OnNewConvChannelSelected={props.OnNewConvChannelSelected}
                    OnNewConvClicked={props.OnNewConvClicked}
                    onNewConvName={props.onNewConvName}
                    onContactListBtnClicked={props.onContactListBtnClicked}

                    onHide={onHideMiddleware}
                    OnContactTabClicked={props.OnContactTabClicked}
                    openNewApiConvByMsgTypeAndClientName={props.openNewApiConvByMsgTypeAndClientName}

                    agentsList={props.agentsList}
                  />
                </Tab>
              )
            }

          </Tabs>
        </Modal.Body>
        <Modal.Footer>
          <Button type='submit' form="contactForm" variant="primary" className='btn-success'>{t('save')}</Button>
          <Button className="mr-auto" variant="secondary" onClick={onHideMiddleware}>{t('Exit')}</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default OpenContactModal;



